import React from 'react';
import { Avatar } from '@material-ui/core';
import Utils from '../providers/Utils';
import Calendar from 'react-calendar';
import Menu from './Menu';
import Ws from '../providers/Ws';
import ro from 'date-fns/locale/ro';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';

import "react-datepicker/dist/react-datepicker.css";
import SpecificComponent from './SpecificComponent';

registerLocale('ro', ro)

export default class TabelTask extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
    }




    ws = new Ws()





    render() {
        return (
            <div>
                <table style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    tableLayout: 'auto',
                    textAlign: 'left'
                }}>
                    <thead>
                        <tr style={{ borderBottom: '1px solid gray', fontSize: 12, lineHeight: '34px' }}>
                            {this.props.headData.map((h, idx) => {
                                return (
                                    <th key={idx}>{h}</th>
                                )
                            })}

                        </tr>
                    </thead>

                    <tbody>
                        {this.props.taskuri.map((t, idx) => {
                            if (!t.edit_task) {
                                return (
                                    <tr className='table-view-row' key={'t' + idx} style={{ borderBottom: '1px solid gray', fontSize: 12, lineHeight: '34px' }}>
                                        <td>
                                            <input
                                                style={{ fontSize: 14, fontWeight: 400 }}
                                                id='titlu-task'
                                                type="text"
                                                className='hidden-input'
                                                margin="normal"
                                                name='titlu'
                                                value={t.titlu || ''}
                                                onChange={(ev) => { this.props.changeTask(ev, t) }}
                                                onBlur={this.props.updateTaskTitle}
                                            />
                                            {/* {t.titlu} */}

                                        </td>
                                        <td style={{ position: 'relative', cursor: 'pointer' }} onClick={() => { this.props.getTaskDates(t, this.props.etapa, true, false) }}>

                                            <DatePicker

                                                // className='add-project-input'
                                                style={{ width: '100%' }}

                                                selected={t.cand_data ? new Date(t.cand_data) : this.props.dtDataStart}
                                                onChange={this.props.dataStartChange}
                                                startDate={this.props.dtDataStart}
                                                shouldCloseOnSelect={true}
                                                calendarClassName="calendar-left-absolute"
                                                locale="ro"
                                                disabled={this.props.readOnly}
                                                dateFormat="dd/MM/yyyy"
                                                customInput={<div    >

                                                    <span style={{fontSize: 14}}>


                                                        {new Utils().ParseDataFromSql(t.cand_data)}

                                                        {/* <i onClick={this.props.showCalendarStart} className='material-icons task-edit'>create</i> */}
                                                    </span>

                                                    {/* <i style={{

                                              fontSize: 18,
                                              verticalAlign: 'middle'

                                          }} className='material-icons'>today</i> */}
                                                </div>}
                                                monthsShown={1}
                                            />



                                            {/* <div style={{
                                                maxWidth: 220, position: 'absolute',
                                                top: 30,
                                                zIndex: 2000
                                            }}>
                                                <Calendar

                                                    className={t.hide_calendar ? 'pm-hide-calendar' : ''}
                                                    locale={'ro'}
                                                    onChange={this.props.dataStartChange}
                                                    value={this.props.dtDataStart}
                                                />

                                            </div> */}
                                        </td>
                                        <td style={{ position: 'relative', cursor: 'pointer' }} onClick={() => { this.props.getTaskDates(t, this.props.etapa, false, true) }}>



                                            <DatePicker

                                                // className='add-project-input'
                                                style={{ width: '100%', backgroundColor:'transparent', fontSize:14 }}
                                                selected={t.pana_cand_data ? new Date(t.pana_cand_data) : this.props.dtDataFinish}
                                                onChange={this.props.dataFinishChange}
                                                startDate={this.props.dtDataFinish}
                                                shouldCloseOnSelect={true}
                                                calendarClassName="calendar-left-absolute"
                                                locale="ro"
                                                disabled={this.props.readOnly}
                                                dateFormat="dd/MM/yyyy"
                                                customInput={<div    >

                                                    <span style={{fontSize:14}}>


                                                        {new Utils().ParseDataFromSql(t.pana_cand_data)}

                                                        {/* <i onClick={this.props.showCalendarStart} className='material-icons task-edit'>create</i> */}
                                                    </span>

                                                    {/* <i style={{

                                              fontSize: 18,
                                              verticalAlign: 'middle'

                                          }} className='material-icons'>today</i> */}
                                                </div>}
                                                monthsShown={1}
                                            />





                                            {/*                                         
                                        <div style={{
                                                maxWidth: 220, position: 'absolute',
                                                top: 30,
                                                zIndex: 2000
                                            }}>
                                                <Calendar

                                                    className={t.hide_calendar_finish ? 'pm-hide-calendar' : ''}
                                                    locale={'ro'}
                                                    onChange={this.props.dataFinishChange}
                                                    value={this.props.dtDataFinish}
                                                />

                                            </div> */}

                                        </td>
                                        <td onClick={() => { this.props.userClick(t) }} style={{ position: 'relative' }}>
                                            {
                                                t.utilizator_responsabil.length > 0 &&
                                                (t.utilizator_responsabil[0].poza ?
                                                    <Avatar
                                                        style={{ display: 'inline-block', marginLeft: 10, width: 30, height: 30, marginTop: 2 }} src={this.ws.adresaMedia + '/Angajati/' + t.utilizator_responsabil[0].poza} />
                                                    :

                                                    <Avatar
                                                        onMouseEnter={() => { this.props.showUserTag(t) }}
                                                        onMouseLeave={() => { this.props.hideUserTag(t) }}
                                                        style={{ display: 'inline-block', width: 30, height: 30, textAlign: 'center', marginLeft: 10, marginTop: 2, backgroundColor: new Utils().culoriUtilizatori(t.utilizator_responsabil[0].id) }}>
                                                        <i style={{ verticalAlign: 'middle' }} className='material-icons'>person</i>
                                                    </Avatar>
                                                )
                                            }

                                            {t.utilizator_responsabil.length === 0 &&
                                                <Avatar

                                                    style={{ display: 'inline-block', width: 30, height: 30, textAlign: 'center', marginLeft: 10, marginTop: 2, backgroundColor: 'pink' }}>
                                                    <i style={{ verticalAlign: 'middle' }} className='material-icons'>person</i>
                                                </Avatar>
                                            }

                                            {
                                                t.utilizator_responsabil.length > 0 &&

                                                <div className='etapa-tag' style={{
                                                    position: 'absolute', display: t.utilizator_responsabil[0].show_tag_task ? 'block' : (t.utilizator_responsabil[0].show_tag_subtask ? 'block' : 'none'), top: 35,
                                                    right: -50, color: 'white', zIndex: 1003
                                                }}>
                                                    <div className='user-tag-container' style={{ position: 'relative', textAlign: 'left' }}>


                                                        <div style={{
                                                            position: 'absolute',
                                                            top: -11,
                                                            left: '45%',
                                                            borderBottomColor: 'rgb(75 75 75)'
                                                        }} className='triangle-up'>

                                                        </div>

                                                        <h4 style={{ marginBottom: 5, fontSize: 14 }}>{t.utilizator_responsabil[0].nume} </h4>
                                                        <span style={{ marginTop: 5, display: "block", fontSize: 12 }}>{this.dictionary.proiecte.department}:{t.utilizator_responsabil[0].nume_departament}</span>


                                                    </div>


                                                </div>
                                            }

                                            <Menu
                                                openMenu={t.utilizator_view}
                                                e={{ id: 2 }}
                                                elSelectat={{ id: 2 }}
                                                closeMenu={this.props.closeUtilizator}
                                                el={this.props.listUsers}
                                                text={'nume'} />
                                        </td>
                                    </tr>
                                )
                            }
                        })}
                    </tbody>


                </table>
            </div>
        );
    }
}